export default "__VITE_ASSET__C1J6nBhg__"